import { useQuery } from 'react-query';
import { getUsers } from '~/api/admin';
import { User } from '~/types/user';
import { usePermissions } from '~/requests/permissions/usePermissions';


export const adminUsersKey = () => 'adminUsers';

export const useAdminUsersQuery = () => {
  const { permissions, isLoading } = usePermissions();

  return useQuery(adminUsersKey(), () => {

    return getUsers({ teamOnly: true })
      .then((users) => {
        return users.filter((user: User) => user.active);
      });
  }, {
    refetchOnWindowFocus: false,
    enabled: !isLoading && permissions?.isAdmin === true,
  });
};